module.exports = {
    GIG_PAGE_V5_EXPERIMENT: 3119,
    OWLS_CHOICE_PRICE_MODALITIES_AUTOMATION_EXP: 3164,
    PORTFOLIO_PRESENCE_ABTEST: 3232,
    FOXES_CREATE_BRIEF: 3253,
    QUAL_REVIEWS_WORK_SAMPLE_MOBILE: 3255,
    QUALAS_GIG_RATING_PROJECT_1: 3273,
    GIG_PAGE_LAYOUT_EXPERIMENT: 3311,
    LIONS_FINAL_PRICE_UPFRONT: 3314,
    QUALAS_REVIEWS_SBSS_INDICATION: 3333,
    GIG_PAGE_VOICE_OVER_AI_AUDITION: 3516,
    PANTHERS_FMP_IMPROVEMENTS: 3462,
    QUAL_REVIEWS_PRICE_RANGES: 3465,
    GOATS_SKIP_EXTRAS_PAGE_WEB: 3471,
    GOATS_SKIP_EXTRAS_PAGE_MOBILE_WEB: 3472,
    MUSTANGS_BUSINESS_ENV_GIG_PAGE: 3475,
    ZEBRAS_FIVERR_USERS_IN_SUBDOMAIN: 3494,
    QUALAS_HIGHLY_RESPONSIVE_INDICATION_ON_GIG_PAGE: 3512,
    GOATS_GUEST_SKIP_CHECKOUT_WEB: 3513,
    GOATS_GUEST_SKIP_CHECKOUT_MOBILE_WEB: 3514,
    GIG_PAGE_NEW_PERSEUS_MAJOR_EXPERIMENT: 3534,
    LIONS_CONTACT_SELLER_MT_PROMOTION: 3537
};
